export default "__VITE_ASSET__0cf2e667__"